import axios from 'axios';
import { APP_API_URL } from 'utils';

export const baseClient = axios.create({
  baseURL: `${APP_API_URL}/api/auth`,
  validateStatus: status => status < 300 || status === 409 || status === 429,
});

baseClient.interceptors.request.use(config => {
  const locale = localStorage.getItem('locale');
  if (locale) {
    config.headers.locale = locale;
  }
  return config;
});
